// @flow
import React from 'react';
import { Icon } from '@finect/tabular-components/Icon';
import { CardInfo, CardText, CardTitle, CardSubTitle, Tagline } from './partials';

type Props = {
  entity: {
    id: string,
    name: string,
    alias: string,
    subtype: string,
    icon?: string,
    company?: string,
    tagline?: string,
    adviser?: boolean,
    verified?: boolean,
    aditionalIcon?: {
      name: string,
      icon: string,
      url: string
    }
  }
};

export const ProfileInfo = ({ entity }: Props) => {
  const { name, alias, icon, company, tagline, verified, aditionalIcon } = entity;
  const baseURL = `https://${process.env.FINECT_BASEURL || 'www.finect.com'}`;
  const path = entity.subtype === 'company' ? '/grupos/' : '/usuario/';
  const entityURL = `${baseURL}${path}${alias}`;
  const upperName = `${name.charAt(0).toUpperCase()}${name.slice(1)}`;

  let subtitle;
  if (company) {
    subtitle = (
      <CardSubTitle>
        <p>{company}</p>
      </CardSubTitle>
    );
  }
  if (aditionalIcon) {
    subtitle = (
      <CardSubTitle>
        <a href={`${baseURL}/${aditionalIcon.url}`}>Certificación {aditionalIcon.name}</a>
      </CardSubTitle>
    );
  }

  return (
    <CardInfo>
      <Icon
        type={entity.subtype}
        size={4}
        alt={upperName}
        image={icon ? icon.includes('image') ? icon : `/image/${icon}` : null}
        margin="0 12px 0 0"
        aditionalIcon={aditionalIcon}
        verified={verified}
        withBorder={entity.subtype === 'company'}
        url={entityURL}
      />
      <CardText centered={!tagline}>
        {subtitle}
        <CardTitle href={entityURL}>{upperName}</CardTitle>
        {tagline ? (
          <Tagline extraMargin={Boolean(subtitle)}>
            {tagline.length > 90 ? `${tagline.slice(0, 87)}...` : tagline}
          </Tagline>
        ) : null}
      </CardText>
    </CardInfo>
  );
};
